export default {
    loading: {
        module: true
    },
    params: {
        branchoffice_id: 0,
        warehouses_id: 0,
        only_exist: 0,
        user_connect: [],
    },
    accounts_from: [],
    contacts:[],
    conciliation_balances:[],
    branchoffices:[],
    warehouses:[],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/conciliation-balances/state.js